export default __webpack_public_path__ + "static/media/InternelSalesOnIcon.2a84a32a.svg";